var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "newContent" }, [
      _c("div", { staticClass: "navContnet" }, [
        _c("div", { staticClass: "flex row-bottom" }, [
          _c(
            "div",
            { staticClass: "row-content", staticStyle: { width: "75px" } },
            [_vm._v("项目名称")]
          ),
          _c("div", { staticClass: "row-content" }, [
            _vm._v(" " + _vm._s(_vm.graphic.name) + " "),
          ]),
        ]),
        _c("div", { staticClass: "flex row-bottom" }, [
          _c(
            "div",
            { staticClass: "row-content", staticStyle: { width: "75px" } },
            [_vm._v("实施主体")]
          ),
          _c("div", { staticClass: "row-content" }, [
            _vm._v(" " + _vm._s(_vm.graphic.orgCompanyName) + " "),
          ]),
        ]),
        _c("div", { staticClass: "flex row-bottom" }, [
          _c(
            "div",
            { staticClass: "row-content", staticStyle: { width: "75px" } },
            [_vm._v("项目分类")]
          ),
          _c("div", { staticClass: "row-content" }, [
            _vm._v(" " + _vm._s(_vm.graphic.dataProjectTypeId.name) + " "),
          ]),
        ]),
        _c("div", { staticClass: "flex row-bottom" }, [
          _c(
            "div",
            { staticClass: "row-content", staticStyle: { width: "75px" } },
            [_vm._v("项目金额")]
          ),
          _c("div", { staticClass: "row-content" }, [
            _c("span", { staticClass: "num" }, [
              _vm._v(
                _vm._s(
                  _vm.graphic.planFundProvince +
                    _vm.graphic.planFundCity +
                    _vm.graphic.planFundOther
                )
              ),
            ]),
            _c("span", { staticClass: "wy" }, [_vm._v("万元")]),
          ]),
        ]),
        _c("div", { staticClass: "flex" }, [
          _c(
            "div",
            { staticClass: "row-content", staticStyle: { width: "75px" } },
            [_vm._v("计划时间")]
          ),
          _c("div", { staticClass: "row-content" }, [
            _c("span", { staticClass: "num" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$formatDate(new Date(_vm.graphic.bdate), "yyyy-MM-dd")
                  ) +
                  " "
              ),
            ]),
            _vm._v(" - "),
            _c("span", { staticClass: "num" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$formatDate(new Date(_vm.graphic.edate), "yyyy-MM-dd")
                  ) +
                  " "
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }